import { subMilliseconds } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { WHALERS_CLUB_TIME_ZONE } from '../constants';

const lastMomentOfPeriod = (periodEndAt: Date) => subMilliseconds(periodEndAt, 1);

export const formatPeriodDeadline = (periodEndAt: Date, pattern: string): string =>
  formatInTimeZone(lastMomentOfPeriod(periodEndAt), WHALERS_CLUB_TIME_ZONE, pattern);
